import { render, staticRenderFns } from "./ServiceInfoAnimation.vue?vue&type=template&id=0f0f62b9&scoped=true"
import script from "./ServiceInfoAnimation.vue?vue&type=script&lang=js"
export * from "./ServiceInfoAnimation.vue?vue&type=script&lang=js"
import style0 from "./ServiceInfoAnimation.vue?vue&type=style&index=0&id=0f0f62b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0f62b9",
  null
  
)

export default component.exports